import React, { useContext } from 'react';
import { ActionsModel } from 'domains/designers/RuleDesigner/models/ActionsModel';
import { RuleOutputPath } from '@decisions/server/DecisionsFramework/Design/Flow';
import { Cell } from '.';
import { ActionList } from 'domains/designers/RuleDesigner/actions/ActionList';
import { ActionsColumn } from 'domains/designers/TruthTable/columns';
import { RuleExecutionResult } from '@decisions/server/DecisionsFramework/Design/Flow/Service/Debugging/Events';
import { getResultBackgroundColor } from 'domains/designers/TruthTable/TruthTableUtils';
import { RuleDesignerContext } from 'domains/designers/RuleDesigner/RuleDesignerContext';
import { getActions } from 'domains/designers/RuleDesigner/RuleActionUtils';

interface IActionsCellProps extends React.HTMLProps<HTMLTableDataCellElement> {
  actionsModel: ActionsModel;
  outputPath: RuleOutputPath;
  executionResult: RuleExecutionResult | null;
}

/**
 * Contains a set of actions which will be invoked if all conditions in a row are truth.
 * Should be visible only if rule allows actions.
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ActionsCell({ actionsModel, outputPath, executionResult, ...otherProps }: IActionsCellProps) {
  const { isDebug } = useContext(RuleDesignerContext);
  const actions = getActions(actionsModel, outputPath);

  return (
    <ActionsColumn style={{ backgroundColor: getResultBackgroundColor(executionResult) }} {...otherProps}>
      <Cell>
        <ActionList
          isDebug={isDebug}
          actions={actions}
          showAddLink={true}
          onAddActionClick={e => actionsModel.showAddMenuItems(e.currentTarget, outputPath)}
        />
      </Cell>
    </ActionsColumn>
  );
}
